// @flow
import React, { Component } from 'react';
import { Route } from 'react-router-dom';
import { CommissionPayoutsDiv } from './CommissionPayoutsStyles';
import HeaderBlock from './HeaderBlock';
import CommissionDueIndex from './CommissionDueIndex';
import CommissionDueShow from './CommissionDueShow';
import CommissionPaidIndex from './CommissionPaidIndex';
import CommissionPaidShow from './CommissionPaidShow';
import FilterBlock from './FilterBlock';

type Props = {};

export default class CommissionPayouts extends Component<Props> {
  handlePayoutIndex = () => (
    <>
      <FilterBlock />
      <CommissionPaidIndex />
    </>
  );

  handlePayoutShow = (props: {}) => (
    <>
      <FilterBlock />
      <CommissionPaidShow {...props} />
    </>
  );

  render() {
    return (
      <CommissionPayoutsDiv>
        <HeaderBlock />
        <Route
          exact
          path="/commission-payouts/due"
          component={CommissionDueIndex}
        />

        <Route
          exact
          path="/commission-payouts/due/:id"
          component={CommissionDueShow}
        />
        <Route
          exact
          path="/commission-payouts/paid"
          render={() => this.handlePayoutIndex()}
        />

        <Route
          exact
          path="/commission-payouts/paid/:id"
          render={props => this.handlePayoutShow(props)}
        />
      </CommissionPayoutsDiv>
    );
  }
}
